<template>
  <div class="mt-3 pb-2 ResumoAverbacoes-addBox">
    <div class="row ResumoAverbacoes-addBox__content">
      <div class="col-12">
        <div class="col-3">
          <div class="form-group">
            <label
              class="label"
              for="data_averbacao">Data Averbação
            </label>
            <input
              id="data_averbacao"
              v-model="averbacao.data_averbacao"
              v-mask="`99/99/9999`"
              v-validate="`date_format:yyyy-MM-dd|date_between:1500-01-01,${limitDate}`"
              :class="{ 'is-invalid': errors.has('data_averbacao') }"
              class="form-control form-control-sm"
              name="data_averbacao"
              placeholder="00/00/0000"
              type="date">
            <small
              v-if="errors.has('data_averbacao')"
              class="invalid-feedback">{{ errors.first('data_averbacao') }}</small>
          </div>
        </div>
      </div>
    
      <div class="col-4 ResumoAverbacoes-addBox__content">
        <div class="form-group ml-3">
          <span class="custom-control custom-switch mr-4">
            <input
              id="certidao"
              v-model="averbacao.averb_acrescida_certidao"
              class="custom-control-input"
              name="tipo_registro"
              type="checkbox"
              @keyup.enter="averbacao.averb_acrescida_certidao = !averbacao.averb_acrescida_certidao">
            <label
              class="custom-control-label"
              for="certidao">Averbação acrescida na certidão</label>
          </span>
        </div>
      </div>

      <div class="col-4 ResumoAverbacoes-addBox__content">
        <div class="form-group">
          <span class="custom-control custom-switch mr-4">
            <input
              id="livro"
              v-model="averbacao.averb_impressa_livro"
              class="custom-control-input"
              name="tipo_registro"
              type="checkbox"
              @keyup.enter="averbacao.averb_impressa_livro = !averbacao.averb_impressa_livro">
            <label
              class="custom-control-label"
              for="livro">Averbação impressa no livro</label>
          </span>
        </div>
      </div>

      <div v-if="!!propTransporte"
           class="col-4 ResumoAverbacoes-addBox__content">
        <div class="form-group">
          <span class="custom-control custom-switch mr-4">
            <input
              id="transporte"
              v-model="averbacao.averb_impressa_transporte"
              class="custom-control-input"
              name="tipo_registro"
              type="checkbox"
              @keyup.enter="averbacao.averb_impressa_transporte = !averbacao.averb_impressa_transporte">
            <label
              class="custom-control-label"
              for="transporte">Averbação impressa no transporte</label>
          </span>
        </div>
      </div>

      <div class="col-7"
           data-tooltip="Escolha a minuta">
        <div class="form-group">
          <div class="tooltipHelp"
               data-tooltip="A minuta selecionada aqui será apresentada na área de texto abaixo para edição">
            <label class="label">Escolha a minuta</label>
            <icon-svg icon="helpCircle"
                      class="iconBlue" />
          </div>

          <select id="titulo_minuta"
                  ref="titulo_minuta"
                  v-model="averbacao.texto_averbacao"
                  class="form-control form-control-sm"
                  name="titulo_minuta"
                  :disabled="!minutas.length">
            <option selected
                    :value="''">
              Selecione
            </option>
            <option v-for="(minuta, index) in minutas"
                    :key="`titulo_minuta${_uid}_${index}`"
                    :value="minuta.descricao">
              {{ minuta.titulo }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-12">
        <textarea
          id=""
          v-model="averbacao.texto_averbacao"
          class="form-control form-control-sm"
          name=""
          rows="5" />
      </div>
    </div>

    <div class="text-right m-2">
      <button class="btn btn-sm btn-danger mr-2"
              @click="hideModal()">
        Cancelar
      </button>
      <button class="btn btn-sm btn-primary"
              @click="store">
        Adicionar
      </button>
    </div>
    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="onSelectCertificado" />
    </b-modal>
  </div>
</template>

<script>
  //services
  import DocumentosService from "@/services/Documentos"
  import MinutasService from "@/services/MinutasService"
  import BryService from '@/services/Assinaturas/BryService'
  import AverbacoesService from "@/services/Registros/AverbacoesService"
  import ImpressaoService from '@/services/Registros/ImpressaoService'

  //filters
  import { maskCPF } from '@/filters/filters'

  //outros
  import moment from 'moment'
  import { mapGetters } from "vuex"

  /* constants */
  import { IMPRIMIR_AVERBACOES, ADMIN } from "@/constants/permissions"

  export default {
    name: 'AverbacaoSV',
    props: {
      propCpf: {type: String, default: null},
      registroId: { type: Number, default: null},
      propShowText: { type: Boolean, default: true },
      propShowTextAnotacao: { type: Boolean, default: false },
      propTarefaId: { type: Number, default: null },
      propTextoProcedimento: { type: String, default: null },
      propImprimir: { type: Boolean, default: false },
      propTransporte: { type: Object, default: null }
    },
    data () {
      return {
        averbacao: {
          data_averbacao: moment(new Date()).format('YYYY-MM-DD'),
          texto_averbacao: '',
          averb_acrescida_certidao: false,
          averb_impressa_livro: false,
          averb_impressa_transporte: false,
          tarefaId: null
        },
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        minutas: [],
        certificadoSelecionado: null,
        certificados: null,
        certificateData: null,
        livroDeRegistro: null,
        IMPRIMIR_AVERBACOES,
        ADMIN,
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        cartorio: 'auth/getCartorioObj'
      })
    },
    async mounted () {
      await this.getMinutas()

      // texto usado na aba de segunda via dos registros
      if (this.propShowText) this.gerarTextoCPF()
      
      // texto usado na tarefa de anotação
      if (this.propShowTextAnotacao) this.gerarTextoAnotacao()
      
      // texto usado na averbação de procedimento
      if (this.propTextoProcedimento) this.averbacao.texto_averbacao = this.propTextoProcedimento

      if (this.propTarefaId) this.averbacao.tarefaId = this.propTarefaId

      const livroDeRegistro = await DocumentosService.getLivroDeRegistro(this.registroId)

      if (livroDeRegistro) {
        this.livroDeRegistro = livroDeRegistro
      }
    },
    methods: {
      store () {
        this.$validator.validate().then(resp => {
          let invalids = document.querySelectorAll('.is-invalid')

          if (resp && invalids.length === 0) {
            this.crud = 'store'

            if (this.livroDeRegistro && this.averbacao.averb_impressa_livro) {
              this.obterCertificados()
            } else {
              this.gravarAverbacao()
            }
          }
        })
      },
      async obterCertificados () {
        loader({ text: 'Validando extensão...', active: true })

        if (!BryService.isExtensionInstalled()) {
          loader({ text: '', active: false })

          objSwal.info.title = 'Extensão não instalada'
          objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
          objSwal.info.html = ''
          objSwal.info.confirmButtonText = 'Instalar'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não'

          return Swal.fire(objSwal.info).then(({ value }) => {
            if (value) {
              try {
                BryService.getExtension()
              } catch (e) {
                displayMessage('error', 'Erro!', e.message)
              } finally {
                this.editTextoAverbacao = ''
              }
            }
          })
        }

        loader({ text: 'Obtendo certificados...', active: true })

        // Retornamos apenas certificados do tipo 'A3'
        const certificados = await BryService.getCertificates()

        this.certificados = certificados.filter(certificate => {
          return certificate.certificateType === 'A3'
        })

        loader({ text: '', active: false })

        if (this.certificados.length === 0) {
          return displayMessage('error', 'Erro!', 'Não foi possível selecionar o certificado. Nenhum certificado foi encontrado')
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          this.gravarAverbacao()
        }
      },
      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado
        // Fechando modal
        this.$refs.modalCertificados.hide()
        // Anulando certificados obtidos
        this.certificados = null

        this.gravarAverbacao()
      },
      gravarAverbacao () {
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de store averbacoes
        AverbacoesService.incluirAverbacao(this.registroId, this.averbacao).then(async (res) => {
          const response = res.data
          try {
            // Só vamos realizar a assinatura quanto tiver Livro de Registro, for impressa no livro e o response retornar o documento do Livro de Registro
            if (this.livroDeRegistro && this.averbacao.averb_impressa_livro && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            await displayMessage('success', 'Averbação cadastrada com sucesso!')
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
      
          })
          .finally(async () => {
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null
            loader({ text: '', active: false })

            if (this.propImprimir) {
              const res = await displayMessage('question', 'Deseja imprimir a averbação gerada?')

              if (res.value) {
                return this.imprimirAverbacao(this.averbacao)
              }
            } 

            this.$emit('reload')            
            this.hideModal()
          })
      },
      async assinaturaAverbacao (documentoLivroDeRegistro) {
        try {
          // Guarda o certificateData para quando assinarmos o Livro de Registro.
          this.certificateData = this.certificadoSelecionado.certificateData

          // Inicia a assinatura
          const iniciaAssinatura = await BryService.startSigning(this.certificateData, documentoLivroDeRegistro.documento_id)

          // Trata o objeto da assinatura
          const assinaturasObj = iniciaAssinatura.assinaturasInicializadas.map(({ nonce, messageDigest }) => {
            return BryService.prepareContentForSignature(messageDigest, nonce)
          })

          const { certId } = this.certificadoSelecionado

          // Digita a senha do certificado
          const { assinaturas } = await BryService.signBase64Content(certId, assinaturasObj)

          // Finaliza a assinatura
          await BryService.endSigning(iniciaAssinatura.nonce, assinaturas)
        } catch (e) {
          console.error(e)
          throw "Erro ao assinar"
        }
      },
      hideModal () {
        this.$emit('hideModal')
      },
      async getMinutas () {
        try {
          loader({ active: true, text: 'Carregando minutas...'})

          const minutas = await MinutasService.getMinuta ({
            cartorio_id: this.$store.state.auth.cartorio_id,
            perPage: 100,
            page: 1,
            tipo_registro: this.tipoRegistro
          })

          this.minutas = minutas.data
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro ao carregar minutas', message.message)
        } finally {
          loader({ active: false, text: ''})
        }
      },
      gerarTextoCPF () {
        let text =  ''

        text += `CPF - O(a) registrado(a) esta inscrito(a) no CPF sob o nº ${this.propCpf ? maskCPF(this.propCpf) : ''},`
        text += ` conforme consulta realizada nesta data na base da RFB/CRC.`
        text += this.cartorio && this.cartorio.endereco ? ` ${this.cartorio.endereco.cidade} - ${this.cartorio.endereco.uf},` : ''
        text += ` ${moment(new Date()).format('DD/MM/YYYY')}. Eu, ${this.user.nome}, ${this.user.cargo}, averbei.`

        this.averbacao.texto_averbacao = text
      },
      gerarTextoAnotacao () {
        this.averbacao.averb_acrescida_certidao = true
        this.averbacao.averb_impressa_livro = true

        let text =  ''

        text += ''

        this.averbacao.texto_averbacao = text
      },
      async imprimirAverbacao (averbacao) {
        // Verificamos a permissão no método pois nenhuma rota é chamada
        // Se for suporte ou oficial não validamos
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [ this.IMPRIMIR_AVERBACOES, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        try {
          loader({active: true})
          const url = await ImpressaoService.etiqueta({ textoImpressao: averbacao.texto_averbacao })

          window.open(url)
        } catch (e) {
          displayMessage('error', 'Erro!', 'Não foi possível gerar o PDF da impressão')
        } finally {
          this.hideModal()
          loader({active: false})
        }
      },
    }
  }
</script>

<style lang="scss">
@import "../../../../scss/_utilities/exports";

.iconBlue {
    fill: #074f7f;
    height: 1.3rem;
    width: 1.3rem;
    margin-bottom: 3px;
    margin-left: 6px;
  }

  .tooltipHelp::before,
  .tooltipHelp::after {
    --scale: 0;
    --tooltip-color: #F9F9F9;
    --tooltip-color-border: rgba(0,0,0,.3);
    position: absolute;
    z-index: 1;
    content: '';
    bottom: -1rem;
    transition: 35ms;
    transform-origin: bottom center;
    transform: translateX(15%) translateY(44%) scale(var(--scale));
  }

  .tooltipHelp::before {
    content: attr(data-tooltip);
    padding: .5rem;
    width: 38%;
    color: black;
    border-radius: .7rem;
    word-wrap: break-word;
    background: var(--tooltip-color);
    box-shadow: inset 0 0 0.1em var(--tooltip-color-border);
    -webkit-filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
    filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
  }

  .tooltipHelp:hover::before,
  .tooltipHelp:hover::after {
    --scale: 1;
  }

  .tooltipHelp:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: solid;
    box-shadow: 0px 10px 20px 10;
    border-width: 0px 10px 20px 10px;
    transform: translateX(-100%) translateY(-240%) scale(var(--scale));
    border-color: transparent transparent var(--tooltip-color) transparent;
    -webkit-filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
    filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
  }

</style>